import { Component, OnInit } from '@angular/core';
import { ConnectionService } from '../../connection.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-token-tracker',
  templateUrl: './token-tracker.component.html',
  styleUrls: ['./token-tracker.component.css']
})
export class TokenTrackerComponent implements OnInit {
  tot: number = 1; ten: number = 1; twn: number = 1; getDecimals: any; inum = '0';
  tokenInfo: any = {}
  tokenCount: any;

  constructor(private conn: ConnectionService, private spinner: NgxSpinnerService) {
    // this.spinner.hide()

  }

  ngOnInit() {
    this.getRecordToken('ABC20');
    this.getTokenCount()
  }

  getRecordToken(type) {
    // this.spinner.show()
    this.conn.postUrl('token/recordToken', { tokenType: type }).subscribe((res: any) => {
      if (res.data.length > 1) {
        this.tokenInfo = res.data
      }
      else {
        // this.spinner.hide()
        this.tokenInfo = res.data[0] ? res.data[0] : res.data
      }
    })
    // this.spinner.hide()

  }

  getTokenCount() {
    this.conn.postUrl('users/tokenCount', {}).subscribe((res: any) => {
      this.spinner.show()
      if (res.success == true) {
        this.tokenCount = res.data
        this.spinner.hide()
      }
    })
  }
}
